<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onBack" />
      </template>
      源泉徴収票の発行
    </Header>

    <div class="withholding px-3 py-4">
      <p class="text-mild text-size-14">
        過去に働いた仕事の源泉徴収票の確認/印刷ができます
      </p>
      <div
        v-if="years.length > 0"
        class="year-list bg-white border border-outline-color px-3 mt-3 round-4"
      >
        <div
          v-for="item in yearWithStatus"
          :key="'year' + item.year"
          class="year-link"
        >
          <RouterLink
            :to="{ name: 'WithholdingSlipList', params: { year: item.year } }"
            class="d-flex justify-content-between align-items-center py-3"
          >
            <p class="text-black text-size-14 text-weight-500">
              {{ item.text }}
            </p>
            <div>
              <AppBadge variant="info" v-if="item.isFixed">
                確定済
              </AppBadge>
              <FeatherIcon icon="chevron-right" class="text-gray-05" />
            </div>
          </RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from "vue-facing-decorator";
import { accountService } from "@/app/services/AccountService";
import { withholdingService } from "@/app/services/WithholdingService";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { showErrorModal } from "@/utils/showErrorModal";
import AppBadge from "@/components/atoms/other/AppBadge.vue";
import { Years } from "@/types/withholding/Years";

@Component({
  components: {
    AppBadge,
    FeatherIcon,
    Header
  }
})
export default class WithholdingIndex extends Vue {
  years: Years[] = [];

  async created() {
    try {
      this.$loading.show();
      // アカウント情報を更新
      await accountService.updateUserData();
      const user = authStore.user!;
      this.years = await withholdingService.fetchYears(user.username);
    } catch (e) {
      showErrorModal(this, e as Error);
    } finally {
      this.$loading.hide();
    }
  }

  onBack() {
    this.$router.back();
  }

  get yearWithStatus() {
    return this.years.map(item => {
      return {
        year: item.year,
        text: `${item.year}年分${
          item.isFixed ? `(${item.year}/01/01〜12/31)` : ""
        }`,
        isFixed: item.isFixed
      };
    });
  }
}
</script>

<style lang="scss" scoped>
.withholding {
  .year-list {
    .year-link:not(:first-child) {
      border-top: 1px solid $outline-color;
    }
  }
}
</style>
